import React from 'react'
import PropTypes from 'prop-types'

// availabilityData is keyed by "YYYY-MM-DD"; a day with no times has [].
export const monthHasSlots = (availabilityData, monthDate) => {
  const prefix = `${monthDate.getFullYear()}-${String(monthDate.getMonth() + 1).padStart(2, '0')}-`
  return Object.entries(availabilityData || {}).some(([day, slots]) => day.startsWith(prefix) && slots.length > 0)
}

// "Full" is only true of the current month or a later one. A past month has no
// times because it is over, and the calendar lets the student page back to it.
export const offersNextMonth = (availabilityData, monthDate, today = new Date()) => {
  const monthStart = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1)
  const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1)
  return monthStart >= thisMonthStart && !monthHasSlots(availabilityData, monthDate)
}

/**
 * Shown in place of the time list when the month on screen has no
 * consultation times left, so the student moves on to the next month instead
 * of reading "pick a date" over a calendar with nothing to pick.
 */
const MonthFullNotice = ({ translations, onNextMonth, primaryColor = '#3366FF' }) => (
  <div className="h-full flex flex-col items-center justify-center text-center gap-3 p-6 border border-gray-200 rounded-xl">
    <p className="text-base font-semibold text-gray-900">{translations.month_full || 'No times left this month'}</p>
    <button
      type="button"
      onClick={onNextMonth}
      className="min-h-[44px] px-5 rounded-lg text-sm font-medium text-white transition-opacity hover:opacity-90"
      style={{ backgroundColor: primaryColor }}
    >
      {translations.see_next_month || 'See next month'} →
    </button>
  </div>
)

MonthFullNotice.propTypes = {
  translations: PropTypes.object.isRequired,
  onNextMonth: PropTypes.func.isRequired,
  primaryColor: PropTypes.string
}

export default MonthFullNotice
